module.exports = __webpack_public_path__ + "img/tuijianyoujiang.8cf7928b.png";